<template>
  <div>
    <!-- <b-card>
    <div slot="header">User Profile</div>-->
    <b-form @submit.prevent="save">
      <!-- <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Location ID</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.location_edit.LocationID"
                placeholder="Location ID"
                required
                disabled
                type="text"
                autocomplete="LocationID"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>-->
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Name</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.location_edit.Name"
                placeholder="Name"
                required
                type="text"
                id="Name"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Address</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.location_edit.Address1"
                placeholder="Primary Address"
                required
                type="text"
                id="Address1"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Ste./Bldg</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.location_edit.Address2"
                placeholder="Secondary Address"
                type="text"
                id="Address2"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>City</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.location_edit.City"
                placeholder="City"
                required
                type="text"
                id="City"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>State</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.location_edit.State"
                placeholder="State"
                required
                type="text"
                id="State"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Zipcode</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.location_edit.PostalCode"
                placeholder="Postal Code"
                required
                type="text"
                id="PostalCode"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Phone</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model="client.location_edit.Phone"
                placeholder="Phone"
                v-mask="'(###) ###-####'"
                required
                type="text"
                id="Phone"
                autocomplete="off"
                v-on:keyup="addDirtyField"
              ></b-form-input>
              <b-button
                style="display:none;"
                class="mr-0 mt-2 invisible"
                size="md"
                variant="primary"
                type="submit"
              ></b-button>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
//import Datepicker from "vuejs-datepicker";
//import "bootstrap/dist/css/bootstrap.css";

// Import this component
import datepicker from "vue-bootstrap-datetimepicker";
//import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  name: "LocationCard",
  computed: {
    ...mapState(["client"]),
    ...mapActions("saveOp", {
      prefix_DestroySaveOperation: "DestroySaveOperation",
      prefix_BuildSaveOperation: "BuildSaveOperation",
      prefix_EmitSave: "EmitSave"
    }),
    ...mapActions("client", {
      prefix_AddLocation: "AddLocation"
    })
  },
  components: {
    datepicker
  },
  data: () => {
    return {
      location: {},
      dirtyFields: [],
      saveUrl: "/Client/SaveLocation"
    };
  },
  methods: {
    save() {
      this.prefix_BuildSaveOperation.then(
        this.prefix_EmitSave.then(this.$store.state.saveOp.DestroySaveOperation)
      );
      this.prefix_AddLocation;
      this.$bvModal.hide("modal-3");
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.$store.state.saveOp.localDirtyFields = this.$store.state.saveOp.localDirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.$store.state.saveOp.localDirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
        console.log(this.$store.state.saveOp.localDirtyFields.length);
      }
    }
  },
  created() {},
  mounted() {
    this.$store.state.saveOp.localUrl = "/Client/SaveLocation/";
    this.$store.state.saveOp.localVariableName = "_cl";
    this.$store.state.saveOp.localVariableObject = this.$store.state.client.location_edit;
    //this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    this.$store.state.saveOp.localFieldToSet = "LocationID";
    this.$store.state.saveOp.localReturnObject = "SaveLocationResult";
  }
};
</script>

<style  scoped>
</style>